type DiagnosticEnv = {
  NODE_ENV?: string;
  VERCEL?: string;
  VERCEL_ENV?: string;
  VERCEL_GIT_COMMIT_REF?: string;
  NEXT_PHASE?: string;
  npm_lifecycle_event?: string;
};

type Breadcrumb = {
  at: string;
  label: string;
  details?: Record<string, unknown>;
};

declare global {
  var __PRERENDER_DIAGNOSTICS_INSTALLED__: boolean | undefined;
  var __PRERENDER_DIAGNOSTIC_BREADCRUMBS__: Breadcrumb[] | undefined;
}

const MAX_BREADCRUMBS = 20;

function shouldLogPrerenderDiagnostics(): boolean {
  if (typeof window !== "undefined") {
    return false;
  }

  return process.env.DEBUG_PRERENDER === "true";
}

function getDiagnosticEnv(): DiagnosticEnv {
  return {
    NODE_ENV: process.env.NODE_ENV,
    VERCEL: process.env.VERCEL,
    VERCEL_ENV: process.env.VERCEL_ENV,
    VERCEL_GIT_COMMIT_REF: process.env.VERCEL_GIT_COMMIT_REF,
    NEXT_PHASE: process.env.NEXT_PHASE,
    npm_lifecycle_event: process.env.npm_lifecycle_event,
  };
}

function summarizeError(input: unknown) {
  if (input instanceof Error) {
    return {
      name: input.name,
      message: input.message,
      stack: input.stack,
    };
  }

  return {
    name: typeof input,
    message: String(input),
  };
}

export function logPrerenderBreadcrumb(label: string, details?: Record<string, unknown>) {
  if (!shouldLogPrerenderDiagnostics()) {
    return;
  }

  const entry: Breadcrumb = {
    at: new Date().toISOString(),
    label,
    details,
  };

  const breadcrumbs = globalThis.__PRERENDER_DIAGNOSTIC_BREADCRUMBS__ ?? [];
  breadcrumbs.push(entry);
  globalThis.__PRERENDER_DIAGNOSTIC_BREADCRUMBS__ = breadcrumbs.slice(-MAX_BREADCRUMBS);

  console.error("[prerender-diagnostics] breadcrumb", entry);
}

export { getDiagnosticEnv, shouldLogPrerenderDiagnostics, summarizeError };
